export const getPoulsardFranceData = () => ({
  name: "Poulsard",
  country: "France",
  region: "Jura",
  description: "Le Poulsard est un cépage emblématique du Jura, produisant des vins rouges légers et fruités ainsi que des rosés délicats. Ce cépage unique, avec sa peau fine et sa couleur claire, est l'expression même de la tradition viticole jurassienne. Le Poulsard est également vinifié en blanc dans certaines appellations comme L'Étoile.",
  type: "grape",
  color: "Rouge",
  origin: "Jura, France",
  characteristics: {
    "Peau": "Très fine, peu colorée",
    "Couleur": "Rouge clair à rosé",
    "Acidité": "Élevée",
    "Tanins": "Faibles à moyens",
    "Rendement": "Moyen à élevé",
    "Maturité": "Précoce"
  },
  aromas: {
    "Primaires": ["Fraise", "Framboise", "Cerise", "Groseille"],
    "Secondaires": ["Épices douces", "Poivre blanc", "Notes florales"],
    "Tertiaires": ["Sous-bois", "Truffe", "Notes animales (avec l'âge)"]
  },
  viticulture: {
    "Climat": "Semi-continental avec influences montagneuses",
    "Sol": "Marnes grises et calcaires du Jurassique",
    "Exposition": "Sud et sud-est",
    "Altitude": "250-400 mètres",
    "Taille": "Guyot simple ou double",
    "Rendement": "45-60 hl/ha"
  },
  vinification: {
    "Macération": "Courte à moyenne (5-10 jours)",
    "Température": "Contrôlée (25-28°C)",
    "Élevage": "Fûts de chêne ou cuves",
    "Durée": "6-12 mois",
    "Spécialités": "Vinification en blanc possible"
  },
  wineStyles: {
    "Rouge": "Vins légers et fruités, couleur claire, acidité vive, tanins souples. Parfaits pour la gastronomie locale.",
    "Rosé": "Rosés délicats et aromatiques, parfaits pour l'apéritif et les entrées.",
    "Blanc": "Vins blancs légers et aromatiques (vinification en blanc, spécialité de L'Étoile)."
  },
  regions: {
    "Jura": {
      "Arbois": "Cœur de production, vins rouges et rosés de qualité",
      "Côtes du Jura": "Production généralisée, styles variés",
      "L'Étoile": "Vinification en blanc, vins délicats"
    }
  },
  statistics: {
    "Surface en France": "350 hectares",
    "Production": "15,000 hectolitres",
    "Concentration": "Jura (100%)",
    "Tendance": "Stable"
  },
  history: "Le Poulsard est un cépage ancien du Jura, probablement d'origine locale. Il est mentionné dans les textes médiévaux et était déjà cultivé au Moyen Âge. Le Poulsard a toujours été associé à la tradition viticole jurassienne et à la gastronomie locale. Aujourd'hui, il reste le cépage emblématique du Jura, produisant des vins uniques et authentiques.",
  foodPairing: "Cuisine traditionnelle jurassienne : Comté, Morbier, saucisse de Morteau, volaille de Bresse, morilles, truites du Doubs, charcuterie locale. Les vins de Poulsard s'accordent parfaitement avec les fromages affinés et la gastronomie locale."
}); 